module.exports = __webpack_public_path__ + "static/img/jumper_mm_20-1.5c312fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/jumper_mm_20-1.svg
// module id = yluL
// module chunks = 0